<div *ngIf="scenario.tariffParameters" class="flex options-container">
  <mat-checkbox
    [(ngModel)]="scenario.tariffParameters.nemNetting"
    (ngModelChange)="update()"
  >
    {{ 'scenario.tariff.nem' | translate }}
  </mat-checkbox>
  <mat-icon
    svgIcon="info-circle"
    class="info-circle icon-14 fill-primary"
    matTooltip="{{ 'scenario.form.tariff.nem_netting' | translate }}"
    alt="info-circle"
  />
</div>
